/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import { Box } from "@mui/material";
import React from "react";
import { convertAnswer, isEmpty } from "../../../../utils/helpers/helpers";
import { quizAnswerType } from "../../utils/constant";

export default function AnswerNormalQuizBoard({ dataList, answerTotal, scrollFunc, resultSolution, isDialog }: any) {
  const getAnswerContent = (question) => {
    if (question?.answer_type === quizAnswerType.SORT_POSITION) {
      return (
        answerTotal?.find((ans) => ans?.question_id === question?.id)?.arrayIndex ||
        Array.from({ length: question?.options?.length }, () => "")
      );
    }
    if (question?.answer_type === quizAnswerType.CONSTRUCTED_RESPONSE) {
      return answerTotal?.find((ans) => ans?.question_id === question?.id)?.selections?.[0];
    }
    const selections = JSON.parse(question?.options[0]?.items[0]?.content || "[]")?.selections;
    const numAnswer = selections?.reduce((partialSum, a) => partialSum + a, 0);
    const defaultAnswer = Array.from({ length: numAnswer }, () => "");
    if (selections?.length === 1) {
      return defaultAnswer?.map(
        (_, ix) => answerTotal?.find((ans) => ans?.question_id === question?.id)?.selections[0]?.split("")[ix] || ""
      );
    }
    return defaultAnswer?.map(
      (_, ix) => answerTotal?.find((ans) => ans?.question_id === question?.id)?.selections.flat()[ix] || ""
    );
  };
  const checkShowChoiceAnswer = (question, optionId) => {
    return answerTotal?.find((ans) => ans?.question_id === question?.id && ans?.selections.includes(optionId));
  };
  const quizSolution = (questionId) => resultSolution?.find((res) => res?.quiz_question_id === questionId);

  const getAnsweredOptions = (question) => {
    const resultQuestion = quizSolution(question?.id);
    let options;
    if (!resultQuestion?.skipped) {
      options =
        resultQuestion?.answered_options?.length === 1
          ? resultQuestion?.answered_options[0]?.split("")
          : resultQuestion?.answered_options;
    } else {
      options = resultQuestion?.correct_options;
    }
    if (question?.answer_type === quizAnswerType.SORT_POSITION) {
      const optionsSortPosition: number[] = [];
      options?.forEach((opsCorrect: any) => {
        question?.options.forEach((ops: any, idx: number) => {
          if (ops?.id === opsCorrect) {
            optionsSortPosition.push(idx + 1);
          }
        });
      });
      return optionsSortPosition;
    }
    return options;
    // const selections = JSON.parse(
    //   question?.options[0]?.items[0]?.content || "[]"
    // )?.selections;
    // return selections?.map((element, index) => {
    //   const sumBeforeIndex =
    //     index > 0 ? selections?.slice(0, index).reduce((a, b) => a + b, 0) : 0;
    //   return index === 0
    //     ? options?.slice(0, element)
    //     : options?.slice(sumBeforeIndex, sumBeforeIndex + selections[index]);
    // });
  };
  return (
    <Box
      style={{
        display: "flex",
        flexWrap: "wrap",
        marginTop: 8,
        maxHeight: 500,
        overflow: "auto"
      }}
      className="text-[13px] text-gray400"
    >
      {dataList?.map((question: any, index: number) => (
        <div key={question?.id} className="flex py-1.5 w-full items-center">
          <span className={`font-semibold w-[24px] ${isDialog && "ml-4"}`}>{index + 1}</span>
          <div
            className={`flex justify-start ${
              question?.answer_type === quizAnswerType.ONE_ANSWER ||
              question?.answer_type === quizAnswerType.MANY_ANSWER
                ? `md:gap-x-[20px] lg:gap-x-[30px] gap-y-[10px] ${isDialog ? "gap-x-[40px]" : ""}`
                : "gap-[10px]"
            } ml-3 w-[calc(100%-24px)] flex-wrap`}
          >
            {question?.answer_type === quizAnswerType.ONE_ANSWER || question?.answer_type === quizAnswerType.MANY_ANSWER
              ? question?.options?.map((op, idx) => (
                  <button
                    type="button"
                    key={idx}
                    onClick={() => scrollFunc(question?.id)}
                    className={`border ${
                      resultSolution
                        ? (() => {
                            if (
                              quizSolution(question?.id)?.correct &&
                              quizSolution(question?.id)?.correct_options.includes(op?.id)
                            ) {
                              return "bg-greenQuiz text-white";
                            }

                            if (
                              quizSolution(question?.id)?.skipped &&
                              quizSolution(question?.id)?.correct_options.includes(op?.id)
                            ) {
                              return "bg-orangeQuiz text-white";
                            }

                            const isWrongAnswerQuiz =
                              !quizSolution(question?.id)?.skipped && !quizSolution(question?.id)?.correct;
                            if (isWrongAnswerQuiz) {
                              if (
                                quizSolution(question?.id)?.answered_options.includes(op?.id) &&
                                !quizSolution(question?.id)?.correct_options.includes(op?.id)
                              ) {
                                return "bg-red text-white";
                              }

                              if (
                                quizSolution(question?.id)?.answered_options.includes(op?.id) &&
                                quizSolution(question?.id)?.correct_options.includes(op?.id)
                              ) {
                                return "bg-greenQuiz text-white";
                              }

                              if (
                                !quizSolution(question?.id)?.answered_options.includes(op?.id) &&
                                quizSolution(question?.id)?.correct_options.includes(op?.id)
                              ) {
                                if (question?.answer_type === quizAnswerType.ONE_ANSWER)
                                  return "bg-greenQuiz text-white";
                                return "bg-purple text-white";
                              }
                            }

                            return "bg-white border border-gray";
                          })()
                        : checkShowChoiceAnswer(question, op?.id)
                        ? "border-greenQuiz text-greenQuiz bg-white"
                        : "border-gray bg-white"
                    } rounded-full w-[32px] h-[32px] flex items-center justify-center`}
                  >
                    <span className="ml-[-1px]">{convertAnswer(idx)[0]}</span>
                  </button>
                ))
              : question?.answer_type === quizAnswerType.CONSTRUCTED_RESPONSE
              ? (() => {
                  if (resultSolution) {
                    return (
                      <div
                        onClick={() => scrollFunc(question?.id)}
                        className={`w-full min-h-[36px] text-white text-[13px] px-4 py-2 rounded-[8px] ${
                          quizSolution(question?.id).skipped
                            ? "bg-orangeQuiz"
                            : quizSolution(question?.id).correct
                            ? "bg-greenQuiz"
                            : "bg-red"
                        }`}
                      >
                        {getAnsweredOptions(question)}
                      </div>
                    );
                  }
                  return (
                    <div
                      className={`text-[13px] ${getAnswerContent(question) ? "text-blackQuiz" : "text-gray400"}`}
                      onClick={() => scrollFunc(question?.id)}
                    >
                      {getAnswerContent(question) || "Đáp án"}
                    </div>
                  );
                })()
              : resultSolution
              ? getAnsweredOptions(question)?.map((ansCorrect, i) => (
                  <button
                    type="button"
                    key={i}
                    onClick={() => scrollFunc(question?.id)}
                    className={`${
                      quizSolution(question?.id)?.correct
                        ? "bg-greenQuiz text-white"
                        : quizSolution(question?.id)?.skipped
                        ? "bg-orangeQuiz text-white"
                        : "bg-red text-white"
                    }  bg-white rounded-full h-[32px] min-w-[32px] flex items-center justify-center ml-[-1px] uppercase px-2`}
                  >
                    {ansCorrect}
                  </button>
                ))
              : getAnswerContent(question)?.map((ans, ix) => (
                  <button
                    type="button"
                    key={ix}
                    onClick={() => scrollFunc(question?.id)}
                    className={`border ${
                      !isEmpty(ans) ? "border-greenQuiz text-greenQuiz" : "border-gray"
                    } bg-white rounded-full h-[32px] min-w-[32px] flex items-center justify-center w-max px-2 uppercase`}
                  >
                    {ans}
                  </button>
                ))}
          </div>
        </div>
      ))}
    </Box>
  );
}
